import { render, staticRenderFns } from "./VersionsDialogBox.vue?vue&type=template&id=2159d19d&scoped=true&"
import script from "./VersionsDialogBox.vue?vue&type=script&lang=js&"
export * from "./VersionsDialogBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2159d19d",
  null
  
)

export default component.exports